import PageTitle from "../../../layouts/PageTitle";
import React, { useState, Fragment, useEffect, useCallback  } from "react";
import {
   UpdateSiteTitle,
   UpdateSiteContactDetails,
   UpdateSiteBusinessHours
} from './Requests';
import './BusinessInfo.css'
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
import {PulseLoader } from "react-spinners";
import { error } from "jquery";

const BusinessInfo = (props) => {
  const [siteTitle, setSiteTitle] = useState(props.site.siteTitle)
  const [addressNameNumber, setAddressNameNumber] = useState(props.site.addressNumberName)
  const [addressFirstLine, setAddressFirstLine] = useState(props.site.addressFirstLine)
  const [addressSecondLine, setAddressSecondLine] = useState(props.site.addressSecondLine)
  const [addressCity, setAddressCity] = useState(props.site.addressCity)
  const [addressCounty, setAddressCounty] = useState(props.site.addressCounty)
  const [addressPostcode, setAddressPostcode] = useState(props.site.addressPostcode)
  const [phoneNumber, setPhoneNumber] = useState(props.site.phoneNumber)
  const [emailAddress, setEmailAddress] = useState(props.site.email)
  const [sundayOpen, setSundayOpen] = useState(props.site.sundayOpen !== null)
  const [sundayOpenTime, setSundayOpenTime] = useState(props.site.sundayOpen !== null ?{hour:props.site.sundayOpen.hour, mins:props.site.sundayOpen.mins}:{hour:null, mins:null})
  const [sundayCloseTime, setSundayCloseTime] = useState(props.site.sundayClose !== null ?{hour:props.site.sundayClose.hour, mins:props.site.sundayClose.mins}:{hour:null, mins:null})
  const [mondayOpen, setMondayOpen] = useState(props.site.mondayOpen !== null)
  const [mondayOpenTime, setMondayOpenTime] = useState(props.site.mondayOpen !== null ?{hour:props.site.mondayOpen.hour, mins:props.site.mondayOpen.mins}:{hour:null, mins:null})
  const [mondayCloseTime, setMondayCloseTime] = useState(props.site.mondayClose !== null ?{hour:props.site.mondayClose.hour, mins:props.site.mondayClose.mins}:{hour:null, mins:null})
  const [tuesdayOpen, setTuesdayOpen] = useState(props.site.tuesdayOpen !== null)
  const [tuesdayOpenTime, setTuesdayOpenTime] = useState(props.site.tuesdayOpen !== null ?{hour:props.site.tuesdayOpen.hour, mins:props.site.tuesdayOpen.mins}:{hour:null, mins:null})
  const [tuesdayCloseTime, setTuesdayCloseTime] = useState(props.site.tuesdayClose !== null ?{hour:props.site.tuesdayClose.hour, mins:props.site.tuesdayClose.mins}:{hour:null, mins:null})
  const [wednesdayOpen, setWednesdayOpen] = useState(props.site.wednesdayOpen !== null)
  const [wednesdayOpenTime, setWednesdayOpenTime] = useState(props.site.wednesdayOpen !== null ?{hour:props.site.wednesdayOpen.hour, mins:props.site.wednesdayOpen.mins}:{hour:null, mins:null})
  const [wednesdayCloseTime, setWednesdayCloseTime] = useState(props.site.wednesdayClose !== null ?{hour:props.site.wednesdayClose.hour, mins:props.site.wednesdayClose.mins}:{hour:null, mins:null})
  const [thursdayOpen, setThursdayOpen] = useState(props.site.thursdayOpen !== null)
  const [thursdayOpenTime, setThursdayOpenTime] = useState(props.site.thursdayOpen !== null ?{hour:props.site.thursdayOpen.hour, mins:props.site.thursdayOpen.mins}:{hour:null, mins:null})
  const [thursdayCloseTime, setThursdayCloseTime] = useState(props.site.thursdayClose !== null ?{hour:props.site.thursdayClose.hour, mins:props.site.thursdayClose.mins}:{hour:null, mins:null})
  const [fridayOpen, setFridayOpen] = useState(props.site.fridayOpen !== null)
  const [fridayOpenTime, setFridayOpenTime] = useState(props.site.fridayOpen !== null ?{hour:props.site.fridayOpen.hour, mins:props.site.fridayOpen.mins}:{hour:null, mins:null})
  const [fridayCloseTime, setFridayCloseTime] = useState(props.site.fridayClose !== null ?{hour:props.site.fridayClose.hour, mins:props.site.fridayClose.mins}:{hour:null, mins:null})
  const [saturdayOpen, setSaturdayOpen] = useState(props.site.saturdayOpen !== null)
  const [saturdayOpenTime, setSaturdayOpenTime] = useState(props.site.saturdayOpen !== null ?{hour:props.site.saturdayOpen.hour, mins:props.site.saturdayOpen.mins}:{hour:null, mins:null})
  const [saturdayCloseTime, setSaturdayCloseTime] = useState(props.site.saturdayClose !== null ?{hour:props.site.saturdayClose.hour, mins:props.site.saturdayClose.mins}:{hour:null, mins:null})
  let errorsOpeningHoursObj = {
    sundayOpen: '',
    sundayClose: '',
    mondayOpen: '',
    mondayClose: '',
    tuesdayOpen: '',
    tuesdayClose: '',
    wednesdayOpen: '',
    wednesdayClose: '',
    thursdayOpen: '',
    thursdayClose: '',
    fridayOpen: '',
    fridayClose: '',
    saturdayOpen: '',
    saturdayClose: '',
  };
  const [openingHoursErrors, setOpeningHoursErrors] = useState(errorsOpeningHoursObj);
  let errorsInfoObj = { NameNumber: '', firstLine: '', secondLine: '', city: '', county: '', mobile: '', postcode:'' };
  const [infoErrors, setInfoErrors] = useState(errorsInfoObj);
  const [siteTitleError, setSiteTitleError] = useState('')
  const [siteTitleButtonLoading, setSiteTitleButtonLoading] = useState(false)
  const [contactButtonLoading, setContactButtonLoading] = useState(false)
  const [businessHoursButtonLoading, setBusinessHoursButtonLoading] = useState(false)
  const [showBusinessHours, setShowBusinessHours] = useState(props.site.showBusinessHours)

    function TimeHandler(value, option, set, object)
  {
    if (option === "openHour")
    {
      set({hour:value, mins:object.mins})
    }
    if (option === "openMins")
    {
      set({hour:object.hour, mins:value})
    }
    if (option === "closeHour")
    {
      set({hour:value, mins:object.mins})
    }
    if (option === "closeMins")
    {
      set({hour:object.hour, mins:value})
    }
  }

  function SubmitOpenHours()
  {
    // console.log(sundayCloseTime)
    let errorHour = false;
    const errorOpenHourObj = { ...errorsOpeningHoursObj };


    if (showBusinessHours)
    {
    
    if (sundayOpen && (0 > sundayOpenTime.hour || sundayOpenTime.hour > 23 || 0 > sundayOpenTime.mins || sundayOpenTime.mins > 59 || !sundayOpenTime.mins || !sundayOpenTime.hour))
      {
        errorOpenHourObj.sundayOpen = "Sunday opening time is invalid"
        errorHour = true
      }
    if (sundayOpen && (0 > sundayCloseTime.hour || sundayCloseTime.hour > 23 || 0 > sundayCloseTime.mins || sundayCloseTime.mins > 59 || !sundayCloseTime.hour || !sundayCloseTime.mins))
      {
        errorOpenHourObj.sundayClose = "Sunday closing time is invalid"
        errorHour = true
      }

    if (mondayOpen && (0 > mondayOpenTime.hour || mondayOpenTime.hour > 23 || 0 > mondayOpenTime.mins || mondayOpenTime.mins > 59 || !mondayOpenTime.hour || !mondayOpenTime.mins))
      {
        errorOpenHourObj.mondayOpen = "Monday opening time is invalid"
        errorHour = true
      }
    if (mondayOpen && (0 > mondayCloseTime.hour || mondayCloseTime.hour > 23 || 0 > mondayCloseTime.mins || mondayCloseTime.mins > 59 || !mondayCloseTime.hour || !mondayCloseTime.mins))
      {
        errorOpenHourObj.mondayClose = "Monday closing time is invalid"
        errorHour = true
      }


    if (tuesdayOpen && (0 > tuesdayOpenTime.hour || tuesdayOpenTime.hour > 23 || 0 > tuesdayOpenTime.mins || tuesdayOpenTime.mins > 59 || !tuesdayOpenTime.hour || !tuesdayOpenTime.mins))
      {
        errorOpenHourObj.tuesdayOpen = "Tuesday opening time is invalid"
        errorHour = true
      }
    if (tuesdayOpen && (0 > tuesdayCloseTime.hour || tuesdayCloseTime.hour > 23 || 0 > tuesdayCloseTime.mins || tuesdayCloseTime.mins > 59 || !tuesdayCloseTime.hour || !tuesdayCloseTime.mins))
      {
        errorOpenHourObj.tuesdayClose = "Tuesday closing time is invalid"
        errorHour = true
      }

    if (wednesdayOpen && (0 > wednesdayOpenTime.hour || wednesdayOpenTime.hour > 23 || 0 > wednesdayOpenTime.mins || wednesdayOpenTime.mins > 59 || !wednesdayOpenTime.hour || !wednesdayOpenTime.mins))
      {
        errorOpenHourObj.wednesdayOpen = "Wednesday opening time is invalid"
        errorHour = true
      }
    if (wednesdayOpen && (0 > wednesdayCloseTime.hour || wednesdayCloseTime.hour > 23 || 0 > wednesdayCloseTime.mins || wednesdayCloseTime.mins > 59 || !wednesdayCloseTime.hour || !wednesdayCloseTime.mins))
      {
        errorOpenHourObj.wednesdayClose = "Wednesday closing time is invalid"
        errorHour = true
      }

    if (thursdayOpen && (0 > thursdayOpenTime.hour || thursdayOpenTime.hour > 23 || 0 > thursdayOpenTime.mins || thursdayOpenTime.mins > 59 || !thursdayOpenTime.hour || !thursdayOpenTime.mins))
      {
        errorOpenHourObj.thursdayOpen = "Thursday opening time is invalid"
        errorHour = true
      }
    if (thursdayOpen && (0 > thursdayCloseTime.hour || thursdayCloseTime.hour > 23 || 0 > thursdayCloseTime.mins || thursdayCloseTime.mins > 59 || !thursdayCloseTime.hour || !thursdayCloseTime.mins))
      {
        errorOpenHourObj.thursdayClose = "Thursday closing time is invalid"
        errorHour = true
      }

    if (fridayOpen && (0 > fridayOpenTime.hour || fridayOpenTime.hour > 23 || 0 > fridayOpenTime.mins || fridayOpenTime.mins > 59 || !fridayOpenTime.hour || !fridayOpenTime.mins))
      {
        errorOpenHourObj.fridayOpen = "Friday opening time is invalid"
        errorHour = true
      }
    if (fridayOpen && (0 > fridayCloseTime.hour || fridayCloseTime.hour > 23 || 0 > fridayCloseTime.mins || fridayCloseTime.mins > 59 || !fridayCloseTime.hour || !fridayCloseTime.mins))
      {
        errorOpenHourObj.fridayClose = "Friday closing time is invalid"
        errorHour = true
      }

    if (saturdayOpen && (0 > saturdayOpenTime.hour || saturdayOpenTime.hour > 23 || 0 > saturdayOpenTime.mins || saturdayOpenTime.mins > 59 || !saturdayOpenTime.hour || !saturdayOpenTime.mins))
      {
        errorOpenHourObj.saturdayOpen = "Satutday opening time is invalid"
        errorHour = true
      }

    if (saturdayOpen && (0 > saturdayCloseTime.hour || saturdayCloseTime.hour > 23 || 0 > saturdayCloseTime.mins || saturdayCloseTime.mins > 59 || !saturdayCloseTime.hour || !saturdayCloseTime.mins))
      {
        errorOpenHourObj.saturdayClose = "Saturday closing time is invalid"
        errorHour = true
      }
    }
      setOpeningHoursErrors(errorOpenHourObj)

      if (errorHour == false)
      {
        setBusinessHoursButtonLoading(true)
        UpdateSiteBusinessHours(showBusinessHours,
          (sundayOpenTime),
          sundayCloseTime,
          mondayOpenTime,
          mondayCloseTime,
          tuesdayOpenTime,
          tuesdayCloseTime,
          wednesdayOpenTime,
          wednesdayCloseTime,
          thursdayOpenTime,
          thursdayCloseTime,
          fridayOpenTime,
          fridayCloseTime,
          saturdayOpenTime,
          saturdayCloseTime
        ).then((res) => {
          notifySuccess("Business Hours Saved")
        }).catch((error) => {
          notifyError("Something went wrong, please try again or contact support")
        }).finally(()=> {
          props.getSite()
          setBusinessHoursButtonLoading(false)
        })
      } else{
        notifyError("Please check your business hours are correct")
      }
  }

  function SubmitSiteTitle()
  {
    if (!siteTitle)
    {
      notifyError("Please check you have provided a site title")
      setSiteTitleError("Invalid site title")
    }
    else{
      setSiteTitleError("")
      setSiteTitleButtonLoading(true)
      UpdateSiteTitle(siteTitle).then((res) => {
        notifySuccess("Site title Saved")
      }).catch((error) => {
        notifyError("Something went wrong, please try again or contact support")
      }).finally(()=> {
        setSiteTitleButtonLoading(false)
        props.getSite()
      })
    }
  }

    function SubmitContactDetails() {
      let error = false;
      const errorInfoObj = { ...errorsInfoObj };

      if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode && !phoneNumber && !emailAddress))
      {

      }
      else{

        if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode) && (phoneNumber || emailAddress))
        {

        }
        else{

      
        if (!addressNameNumber)
          {
            errorInfoObj.NameNumber = "Address name or number cannot be empty"
            error = true
          }
        if (!addressFirstLine)
          {
            errorInfoObj.firstLine = "First line of address cannot be empty"
            error = true
          }
        if (!addressCity)
          {
            errorInfoObj.city = "Please enter a city or town"
            error = true
          }
        if (!addressPostcode)
          {
            errorInfoObj.postcode = "Postcode cannot be empty"
            error = true
          }
        }
      }
      if (error)
      {
        notifyError("Please check you have filled out the contact details correctly")
      }

    setInfoErrors(errorInfoObj)
    if (error === false) {
        setContactButtonLoading(true)
        UpdateSiteContactDetails(addressNameNumber, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode, phoneNumber, emailAddress).then((res) => {
          notifySuccess("Contact Details Saved")
        }).catch((error) => {
          notifyError("Something went wrong, please try again or contact support")
        }).finally(()=> {
          props.getSite()
          setContactButtonLoading(false)
        })

    }
  }

  function businessDayHandler(e, type)
  {
    type(e.target.checked)    
    if (!e.target.checked)
    {
      if (e.target.id == "sundayCheck")
      {
        setSundayOpenTime({hour:null, mins:null})
        setSundayCloseTime({hour:null, mins:null})
      }
      if (e.target.id == "mondayCheck")
      {
        setMondayOpenTime({hour:null, mins:null})
        setMondayCloseTime({hour:null, mins:null})
      }
      if (e.target.id === "tuesdayCheck")
      {
        setTuesdayOpenTime({hour:null, mins:null})
        setTuesdayCloseTime({hour:null, mins:null})
      }
      if(e.target.id === "wednesdayCheck")
      {
        setWednesdayOpenTime({hour:null, mins:null})
        setWednesdayCloseTime({hour:null, mins:null})
      }
      if(e.target.id === "thursdayCheck")
      {
        setThursdayOpenTime({hour:null, mins:null})
        setThursdayCloseTime({hour:null, mins:null})
      }
      if(e.target.id === "fridayCheck")
      {
        setFridayOpenTime({hour:null, mins:null})
        setFridayCloseTime({hour:null, mins:null})
      }
      if(e.target.id === "saturdayCheck")
        {
          setSaturdayOpenTime({hour:null, mins:null})
          setSaturdayCloseTime({hour:null, mins:null})
        }
    }


  }

  return (
    <div>
      <ToastContainer/>
      <label style={{marginTop:"2rem"}} htmlFor="site-title">Site Title <span className="required">*</span></label>
      <input maxLength={40} value={siteTitle} required onChange={(e) => {setSiteTitle(e.target.value)}} type="text" id="site-title" placeholder="Business Name"/>
      {siteTitleError && <div className="text-danger fs-12">{siteTitleError}</div>}
      <button disabled={siteTitleButtonLoading} style={{marginTop:0, marginTop:"2rem"}}  onClick={() => {SubmitSiteTitle()}} className='save-button button'>
        {!siteTitleButtonLoading ?
        "Save":
        <PulseLoader 
          color={'#eee'}
          loading={siteTitleButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
      </button>

      <h3 style={{marginTop:"7rem"}}>Address Details</h3>
      <p>This address will be used in the footer of your site as well as being included on your emails to your clients</p>
      <label style={{marginTop:0}} htmlFor="address-number-name">Number or Name</label>
      <input maxLength={45} value={addressNameNumber} onChange={(e) => {setAddressNameNumber(e.target.value)}} type="text" id="address-number-name" placeholder="Number / Name"/>
      {infoErrors.NameNumber && <div className="text-danger fs-12">{infoErrors.NameNumber}</div>}
      
      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-first-line">First Line</label>
      <input maxLength={45} value={addressFirstLine} onChange={(e) => {setAddressFirstLine(e.target.value)}} type="text" id="address-first-line" placeholder="First Line"/>
      {infoErrors.firstLine && <div className="text-danger fs-12">{infoErrors.firstLine}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-second-line">Second Line</label>
      <input maxLength={45} value={addressSecondLine} onChange={(e) => {setAddressSecondLine(e.target.value)}} type="text" id="address-second-line" placeholder="Second Line"/>
      {infoErrors.secondLine && <div className="text-danger fs-12">{infoErrors.secondLine}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-city">City</label>
      <input maxLength={45} value={addressCity} onChange={(e) => {setAddressCity(e.target.value)}} type="text" id="address-city" placeholder="City"/>
      {infoErrors.city && <div className="text-danger fs-12">{infoErrors.city}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-county">County</label>
      <input maxLength={45} value={addressCounty} onChange={(e) => {setAddressCounty(e.target.value)}} type="text" id="address-county" placeholder="County"/>
      {infoErrors.county && <div className="text-danger fs-12">{infoErrors.county}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-postcode">Postcode</label>
      <input value={addressPostcode} onChange={(e) => {setAddressPostcode(e.target.value)}} type="text" id="address-postcode" placeholder="Postcode"/>
      {infoErrors.postcode && <div className="text-danger fs-12">{infoErrors.postcode}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="phone-number">Email Address <span style={{fontSize:"0.8rem"}}>(use am email that you want your clients to contact you on)</span></label>
      <input maxLength={45} value={emailAddress} onChange={(e) => {setEmailAddress(e.target.value)}} type="email" id="email" placeholder="Email"/>

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="phone-number">Phone Number <span style={{fontSize:"0.8rem"}}>(use a mobile that you want your clients to contact you on)</span></label>
      <input maxLength={12} value={phoneNumber} onChange={(e) => {setPhoneNumber(e.target.value)}} type="tel" id="tel" placeholder="Phone Number"/>
      {infoErrors.mobile && <div className="text-danger fs-12">{infoErrors.mobile}</div>}

      <button disabled={contactButtonLoading} onClick={SubmitContactDetails} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                {!contactButtonLoading ?
        "Save Contact Details":
        <PulseLoader 
          color={'#eee'}
          loading={contactButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
      </button>

      <h3 style={{marginTop:"7rem", marginBottom:"1.5rem"}}>Opening Hours</h3>
      <div className="open-hour-wrapper">
        <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
          <input
            // style={{width:"0.25rem", height:"0.25rem"}}
            type='checkbox'
            className='form-check-input'
            id='showBusinessHoursCheck'
            defaultChecked={showBusinessHours}
            onChange={(e) => { setShowBusinessHours(e.target.checked);}}
          />
          <label className='form-check-label' htmlFor='showBusinessHoursCheck'>
              Show business opening hours to your customers
          </label>
        </div>
        {showBusinessHours
        ?
        <div>
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"0.25rem", height:"0.25rem"}}
              type='checkbox'
              className='form-check-input'
              id='mondayCheck'
              defaultChecked={mondayOpen}
              onChange={(e) => { businessDayHandler(e, setMondayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='mondayCheck'>
                Monday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!mondayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={mondayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setMondayOpenTime, mondayOpenTime)}} type="number" max={23} min={0}/>
            :
            <input maxLength={2} disabled={!mondayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={mondayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setMondayOpenTime, mondayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!mondayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={mondayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setMondayCloseTime, mondayCloseTime)}} max={23} min={0} type="number"/>
            :
            <input maxLength={2} disabled={!mondayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={mondayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setMondayCloseTime, mondayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.mondayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.mondayOpen}</div>}
          {openingHoursErrors.mondayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.mondayClose}</div>}
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"0.25rem", height:"0.25rem"}}
              type='checkbox'
              className='form-check-input'
              id='tuesdayCheck'
              defaultChecked={tuesdayOpen}
              onChange={(e) => { businessDayHandler(e, setTuesdayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='tuesdayCheck'>
                Tuesday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!tuesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={tuesdayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setTuesdayOpenTime, tuesdayOpenTime)}} type="number" max={23} min={0}/>
            :
            <input maxLength={2} disabled={!tuesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={tuesdayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setTuesdayOpenTime, tuesdayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!tuesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={tuesdayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setTuesdayCloseTime, tuesdayCloseTime)}} max={23} min={0} type="number"/>
            :
            <input maxLength={2} disabled={!tuesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={tuesdayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setTuesdayCloseTime, tuesdayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.tuesdayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.tuesdayOpen}</div>}
          {openingHoursErrors.tuesdayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.tuesdayClose}</div>}
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              
              type='checkbox'
              className='form-check-input'
              id='wednesdayCheck'
              defaultChecked={wednesdayOpen}
              onChange={(e) => { businessDayHandler(e, setWednesdayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='wednesdayCheck'>
                Wednesday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!wednesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={wednesdayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setWednesdayOpenTime, wednesdayOpenTime)}} type="number" max={23} min={0}/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!wednesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={wednesdayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setWednesdayOpenTime, wednesdayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!wednesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={wednesdayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setWednesdayCloseTime, wednesdayCloseTime)}} max={23} min={0} type="number"/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!wednesdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={wednesdayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setWednesdayCloseTime, wednesdayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.wednesdayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.wednesdayOpen}</div>}
          {openingHoursErrors.wednesdayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.wednesdayClose}</div>}
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"0.25rem", height:"0.25rem"}}
              type='checkbox'
              className='form-check-input'
              id='thursdayCheck'
              defaultChecked={thursdayOpen}
              onChange={(e) => { businessDayHandler(e, setThursdayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='thursdayCheck'>
                Thursday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!thursdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={thursdayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setThursdayOpenTime, thursdayOpenTime)}} type="number" max={23} min={0}/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!thursdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={thursdayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setThursdayOpenTime, thursdayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!thursdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={thursdayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setThursdayCloseTime, thursdayCloseTime)}} max={23} min={0} type="number"/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!thursdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={thursdayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setThursdayCloseTime, thursdayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.thursdayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.thursdayOpen}</div>}
          {openingHoursErrors.thursdayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.thursdayClose}</div>}
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"0.25rem", height:"0.25rem"}}
              type='checkbox'
              className='form-check-input'
              id='fridayCheck'
              defaultChecked={fridayOpen}
              onChange={(e) => { businessDayHandler(e, setFridayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='fridayCheck'>
                Friday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!fridayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={fridayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setFridayOpenTime, fridayOpenTime)}} type="number" max={23} min={0}/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!fridayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={fridayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setFridayOpenTime, fridayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!fridayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={fridayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setFridayCloseTime, fridayCloseTime)}} max={23} min={0} type="number"/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!fridayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={fridayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setFridayCloseTime, fridayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.fridayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.fridayOpen}</div>}
          {openingHoursErrors.fridayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.fridayClose}</div>}
        <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"0.25rem", height:"0.25rem"}}
              type='checkbox'
              className='form-check-input'
              id='saturdayCheck'
              defaultChecked={saturdayOpen}
              onChange={(e) => { businessDayHandler(e, setSaturdayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='saturdayCheck'>
                Saturday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!saturdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={saturdayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setSaturdayOpenTime, saturdayOpenTime)}} type="number" max={23} min={0}/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!saturdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={saturdayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setSaturdayOpenTime, saturdayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!saturdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={saturdayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setSaturdayCloseTime, saturdayCloseTime)}} max={23} min={0} type="number"/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!saturdayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={saturdayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setSaturdayCloseTime, saturdayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.saturdayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.saturdayOpen}</div>}
          {openingHoursErrors.saturdayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.saturdayClose}</div>}
                  <div className="open-hour-day-wrapper">
          <div style={{display:"flex", paddingLeft:"1.5rem"}} className='form-check check-switch custom-checkbox me-4 mb-2'>
            <input
              // style={{width:"1rem", height:"1rem"}}
              type='checkbox'
              className='form-check-input'
              id='sundayCheck'
              defaultChecked={sundayOpen}
              onChange={(e) => { businessDayHandler(e, setSundayOpen)}}
            />
            <label className='form-check-label testt' htmlFor='sundayCheck'>
                Sunday
            </label>
          </div>
          <div style={{display:"flex"}}>
            <input maxLength={2} disabled={!sundayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem"}} value={sundayOpenTime.hour} onChange={(e) => {TimeHandler(e.target.value, "openHour", setSundayOpenTime, sundayOpenTime)}} type="number" max={23} min={0}/>
            :
            <input maxLength={2} disabled={!sundayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginRight:"0.5rem", marginLeft:"0.5rem"}} value={sundayOpenTime.mins} onChange={(e) => {TimeHandler(e.target.value, "openMins", setSundayOpenTime, sundayOpenTime)}} max={59} min={0} type="number"/>
            -
            <input maxLength={2} disabled={!sundayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem", marginRight:"0.5rem"}} value={sundayCloseTime.hour} onChange={(e) => {TimeHandler(e.target.value, "closeHour", setSundayCloseTime, sundayCloseTime)}} max={23} min={0} type="number"/>
                {/* {errors.sundayErrors && <div className="mt-2 text-danger fs-12">{errors.sundayErrors}</div>} */}
            :
            <input maxLength={2} disabled={!sundayOpen} style={{marginBottom:"1.2rem", padding:"0.25rem", marginLeft:"0.5rem"}} value={sundayCloseTime.mins} onChange={(e) => {TimeHandler(e.target.value, "closeMins", setSundayCloseTime, sundayCloseTime)}} max={59} min={0} type="number"/>
          </div>
        </div>
          {openingHoursErrors.sundayOpen && <div className="text-danger fs-12 mb-4">{openingHoursErrors.sundayOpen}</div>}
          {openingHoursErrors.sundayClose && <div className="text-danger fs-12 mb-4">{openingHoursErrors.sundayClose}</div>}
        </div>
        :
        <>
        </>
        }
      </div>
      <button disabled={businessHoursButtonLoading} style={{marginTop:0}} onClick={e => {SubmitOpenHours()}} className='save-button button mt-5'>
                {!businessHoursButtonLoading ?
        "Save Opening Hours":
        <PulseLoader 
          color={'#eee'}
          loading={businessHoursButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
      </button>
    </div>
    );
}

export default BusinessInfo;


